import '../styles/index.scss';
import "magnific-popup/dist/magnific-popup.css";
import "magnific-popup";
import '../../node_modules/owl.carousel/dist/owl.carousel.js';
import swal from 'sweetalert';


class Main {
    constructor() {
        this.onDOMLoaded();
        this.onDocumentLoad();
        this.onDOMResize();
        this.onScrollDownAddBackdropSiteHeader();
        window.jQuery = $;
        window.$ = $;
    }

    onDocumentLoad() {
        window.addEventListener("load", (event) => {
             
        });
    }

    onDOMLoaded() {
        document.addEventListener("DOMContentLoaded", (event) => {
           this.handleWidthChangePaginationNextPrev();
           $(".blog-list.owl-carousel").owlCarousel({
                loop:false,
                responsive:{
                    0:{
                        items:1,
                        stagePadding:30
                    },
                    768:{
                        items:2,
                        stagePadding:70   
                    },
                    1024:{
                        items:3,
                        stagePadding:140
                    },
                },
                margin:30,
           });

           

           if( window.screen.width < 768 ) {

                $(".result-block .product-card-list").owlCarousel({
                    loop:false,
                    items:1,
                    nav:true,
                    margin:30
                });

                $('#menu-item-399 a:first, #menu-item-2263 a:first').click( function (e) {
                    e.preventDefault();
                });

                $('.product-checkout-details .product-table-details tbody tr:nth-child(1)').remove();
                
                $('.product-checkout-details .product-table-details tbody tr.total-cal').insertAfter('.product-checkout-details .product-table-details tbody');

                $('.product-checkout-details .product-card-list, .product-checkout-details .product-table-details tbody')
                .css('display', 'block')
                .addClass('owl-carousel owl-theme')
                .owlCarousel({
                    loop:false,
                    nav: false,
                    dots: false,
                    responsive: {
                        0: {
                            items:1,
                            stagePadding: 70
                        }
                    },
                    margin: 20
               });
           }


           $(".mobile-menu").click( function() {
                 $("html").toggleClass("menu-active");
            });

             $('[data-select-value]').each( function () {
                 this.value = this.getAttribute('data-select-value');
             });

             $(".play-video").click(function() {
                var id = $(this).attr('data-src');
                $("#videoModal").fadeIn();
                var url = 'https://www.youtube.com/embed/'+ id;
                var html = `<iframe id="player" src="`+url+`?autoplay=1&rel=0" width="100%" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>`;
                $("#videoModal").find('.modalContentInner').html(html); 
                $('html').addClass('modalActive'); 
             });

             $('.menu-item-has-children').click( function () {
                $(this).find('.sub-menu').toggleClass('active');
             });

            $(".close_modal").click( function() {
                $("#videoModal").find('.modalContentInner').empty(); 
                $(".customModal").fadeOut();
                $('html').removeClass('modalActive'); 
            });

            $(".openpaybillmodal").click(function() {
                $(".paybillmodal").fadeIn();
            });

            $(".link-redo-list").click(function () {
                $("#clearlist-modal").fadeIn();
            });

            $(".discount_cta").click(function() {
                $("#discountModal").fadeIn();
            });

            



//  *************** TOGGLE FILTER ******************
    
    $(".filter .toggle-head").click(function() {
        $(".filter .toggle-row-js").slideToggle();
    });

    $(".product-term-items .toggle_product").click(function(){
        $(this).parents(".product-term-items").children(".products-items-list").slideToggle();
        $(this).children("i").toggleClass("fa-chevron-down fa-chevron-up");
    });

//  *************** ZIPCODE MODAL ******************

    $('.zipcode_text strong, .zipcode_text b').addClass('zipcode_change');

    $(document).on('click', ".zipcode_change", function() {
        $("#zipcode").fadeIn();
    });

//  *************** PRODUCT LOAD MORE ******************
    
    // function hideProductsLoadMore() {
    //     $('.products-items-list').each(function() {
    //         $(this).find(".product-item").not( $(this).find('.product-item:lt(4)') ).hide();
    //     });
    // }
    // hideProductsLoadMore();
    $(document).on('click', ".load_more button", function() {


        var currentSiteLang = $('body').data('currentlang');
        console.log(currentSiteLang);
        var $elem       = $(this).parents(".products-items-list");
        const urlParams = new URLSearchParams( window.location.search );
        var data = {
            action: 'load_products',
            offset: 4,
            term: $(this).attr('term'),
            type_term_id: $(this).attr('type'),
            p3_currentlang:  currentSiteLang
        };
        let filter_keys = ['dimensions','length','thickness','subtype','quantity'];
        data.filters = [];

        for(let i = 0; i < filter_keys.length; i++) {
            let value = urlParams.get(filter_keys[i]);
            if(value == '') continue;
            data.filters.push({
                "taxonomy": filter_keys[i] == 'dimensions' ? 'dimension' : filter_keys[i],
                "value": value
            });
        }

        $.ajax({
                url     :  AJAX_URL,
                type    : "POST",
                dataType: "JSON",
                data    :  data,
                success: function(response) {
                  //  console.log(response);
                    $($elem).html(response.data);
                }
            
        });

    });

//  *************** INCREASE QTY ******************

    $("body").on('click', ".qty-increase", function() {

        console.log("test click");

        var elem       = $(this).siblings('.qty-val');
        var cart       = $(this).siblings(".cart");
        var removeCart = $(this).siblings(".del-cart");

        $(this).siblings(".qty-decrease").removeAttr('disabled');
        $(elem).val( parseInt(  $(elem).val() ) + 1  );
        if( $(cart).hasClass("hide-icon") ) {
            $(removeCart).addClass('hide-icon').removeClass("show-icon");
            $(cart).removeClass('hide-icon').addClass('show-icon');
        }
    });

// *************** QTY CHANGE ******************

     $("body").on('change', ".qty-val", function() {
        console.log('test');
        var $elem = $(this).siblings('.qty-decrease');
        if ( parseInt( $(this).val() ) < 1 ) {
            $elem.removeAttr('enabled','enabled').attr('disabled','disabled');
        } else {
            $elem.removeAttr('disabled','disabled').attr('enabled','enabled');
        }
    });

//  *************** DESCREASE QTY ******************
        
    $("body").on('click', ".qty-decrease", function() {
        var elem  = $(this).siblings(".qty-val");
        $(elem).val( parseInt( $(elem).val() ) - 1 );
        if ( parseInt( $(this).siblings(".qty-val").val() ) < 1 ) {
            $(this).attr('disabled','disabled');
        }
    });

//  *************** update count ******************

    const update_cart_count = (count = null) => {
        var count = count == null ? $('.cart-items-count').text() : count;
        $('.cart-items-count').html(count);
        $('.cart-items-count').parents(".cart-count").css('display', count > 0 ? 'block' : 'none'); 
    };
    update_cart_count();

//  *************** ADD TO CART ******************
            

            $("body").on('click', ".cart", function() {
                var quantity   = $(this).siblings(".qty-val");
                var qtyMinus   = $(this).siblings(".qty-decrease");
                if ( parseInt( quantity.val() ) < 1 ) {
                    swal({
                          text: "Please add the product quantity",
                          icon: "error",
                     });
                    return;
                } 
                var elem  = $(this);
                var delCart  = $(this).siblings('.del-cart');
                var data = {
                    action  : 'add_to_cart',
                    product : $(elem).attr('pro-id'),
                    qty     : quantity.val()
                };
                $.ajax({
                    url     :  AJAX_URL,
                    type    : "POST",
                    dataType: "JSON",
                    data    :  data,
                    success : function(response) {
                       /* $(delCart).addClass('show-icon').removeClass("hide-icon");
                        $(elem).removeClass('show-icon').addClass('hide-icon'); */
                        $(quantity).val(0);
                        $(qtyMinus).attr("disabled", "disabled");
                        update_cart_count(response.count);
                        
                         
                    },
                    
                }).done(function(){
                     if( $(elem).hasClass('relevant-pro') ) {
                           // window.location.reload();
                           setTimeout(function() {
                                window.location.href = window.location.href; 
                           }, 1000);
                    }
                });

            });

//  *************** REMOVE TO CART ******************


$("body").on('click', ".del-cart", function() {
    var elem  = $(this);
    var cart  = $(this).siblings('.cart');
    var data = {
        action  : 'del_to_cart',
        product : $(elem).attr('pro-id')
    };
    $.ajax({
        url     :  AJAX_URL,
        type    : "POST",
        dataType: "JSON",
        data    :  data,
        success : function(response) {
            $(cart).addClass('show-icon').removeClass("hide-icon");
            $(elem).removeClass('show-icon').addClass('hide-icon');
            swal({
                  text: "Product Deleted Successfully",
                  icon: "success",
                });
            update_cart_count(response.count);
            if( $(elem).hasClass('relevant-pro') ) {
                window.location.reload();
            }
        }

    });
});


//  *************** SAVE LIST ******************
    

$("body").on('click', ".save_list", function() {
    $(this).addClass('no-event');
    var elem  = $(this);
    var data = {
        action  : 'save_list',
    };
    $.ajax({
        url     :  AJAX_URL,
        type    : "POST",
        dataType: "JSON",
        data    :  data,
        success : function(response) {
            if( response['status'] ) {
                console.log(response['url']);
                window.location.href = response['url'];
            }

        }

    });

});

//  *************** EDIT LIST ******************

$("body").on('click', ".edit_list", function() {
    $(this).addClass('no-event');
    var data = {
        action  : 'edit_list',
        id      : $(this).attr('list-id')
    };
    $.ajax({
        url     :  AJAX_URL,
        type    : "POST",
        dataType: "JSON",
        data    :  data,
        success : function(response) {
            window.location.href = response['url'];
        }
    });

});

//  *************** EXIT EDIT MODE ******************
    

    $("body").on('click', ".exit_edit_mode", function() {
        var data = {
            action  : 'exit_edit_mode',
        };
        $.ajax({
              url     :  AJAX_URL,
              type    : "POST",
              data    :  data,
              success : function(response) {
                 window.location.reload();
              }
        });
    });

//  *************** USER DASHBOARD HEADER ACTIVE ******************

    $(window).on("load", function() {
        var url  = window.location.href;
        var link = url.substr(0, url.length-1);
        console.log(link);
        $('.user-dashboard-menu ul li a[href="'+link+'"]').addClass("active");
        
        /* 
        * hide cookie law if cart count is present
        * hide cart count except sei pages 
        */
        (function() {
            if (!document.querySelector('#cookie-law-info-again')) {
                return;
            }
            if (window.location.pathname.includes("/sei/")) {
                document.querySelector('#cookie-law-info-again').style.display = 'none';
            } else {
                if (document.querySelector('.cart-count')) {
                    document.querySelector('.cart-count').style.display = 'none';
                }
            }
        })();
    });

//  *************** LIST RENAME ******************
    
    $(".edit_list .edit_list_btn").click(function(e){
        e.stopPropagation();
        $(".modal").fadeIn();
        $(".modal .list-title").val($(this).parents('.title').find('h3').text());
        $(".rename-list").attr('id',$(this).attr('id'));
    });

    //  *************** DELETE USER PRODUCT LIST ******************
    
    $(".edit_list .delete_list_btn").click(function(e) {
        e.stopPropagation();
        var data = {
            id         : $(this).attr('id'), 
            action     : 'delete_user_product_list',
        };
        swal({
              text: $(".register-list-row").attr("data-delete-list"),
              icon: "warning",
              buttons: [
                    global_lang.no,
                    global_lang.yes
             ],
        }).then(function(isConfirm) {
            if (isConfirm) {
                $.ajax({
                      url     :  AJAX_URL,
                      type    : "POST",
                      data    :  data,
                      success : function(response) {
                         window.location.reload();
                      }
                 });
            }
        });
    });

    $(".close").click(function(){
        $(".modal").fadeOut();
    });

    $(".rename-list").click(function(){
         var data = {
            id         : $(this).attr('id'), 
            title      : $(this).parents('.modal-body').find(".list-title").val(), 
            action     : 'rename_list',
        };
        $.ajax({
              url     :  AJAX_URL,
              type    : "POST",
              data    :  data,
              success : function(response) {
                 window.location.reload();
              }
        });
    });

//  *************** FILTERS ******************
    
    $("#products_type").change(function() {
        handleProductTypeChangeAjax(this);
    });

    if($("#products_type").val() != '') {
        handleProductTypeChangeAjax($("#products_type") , false);
    }

    function handleProductTypeChangeAjax(element, update_list = true) {
        var data = {
            product_type : $(element).val(), 
            term_id      : $(element).attr('data'),
            action       : 'products_filters'
        };

        $.ajax({
            url     :  AJAX_URL,
            type    : "POST",
            dataType: "JSON",
            data    :  data,
            success : function(response) {
                if( update_list ) {
                    $(".products-term-list + .products-term-list").remove();
                    $(".products-term-list").html( response.data );
                }

                filter_items_show_basis_on_type(response.post_terms,'dimensions','#product_dimension','Dimensions');
                filter_items_show_basis_on_type(response.post_terms,'length','#length','Longeur');
                filter_items_show_basis_on_type(response.post_terms,'thickness','#thickness','Épaisseur');
                filter_items_show_basis_on_type(response.post_terms,'subtype','#subtype','Spécifications');
                filter_items_show_basis_on_type(response.post_terms,'quantity','#quantity','Quantité');
            },
            // complete: function() {
            //     hideProductsLoadMore();
            // }
        });
    }

function filter_items_show_basis_on_type(obj,key,elem,text) {
    const urlParams = new URLSearchParams( window.location.search );

    if( obj !== null && obj !== '' && obj[key] != undefined) {
       $(".form-row").show();
       //$("button").show();
       $(elem).show(); 
       $(elem).parent('form-group').show(); 
       var html = '<option value="">'+ text +'</option>';
       var obj  = obj[key];
       for ( let item in obj ) {
        html += '<option value="'+item+'" '+ (urlParams.get(key) == item ? 'selected' : '') +'>'+obj[item][item]+'</option>';
      }
       $(elem).html(html);

    } else {
         // $(".form-row").hide();
         $(elem).hide(); 
         $(elem).parent('.form-group').hide(); 
    }  
}


//  *************** ACCORDION ******************


    $(".accordion-row .item .title").click(function() {
        if( $(this).parent().hasClass("active") ) {
            $(this).siblings(".description").slideToggle();
            $(this).parent().removeClass('active');  
            $(this).children("i").toggleClass("fa-chevron-up fa-chevron-down");          
          } else{ 
                $(".accordion-row .item").removeClass("active");
                $(".accordion-row .item .description").slideUp();
                $(this).siblings(".accordion-row .item .description").slideToggle();
                $(this).parent().addClass('active');
                $(".accordion-row .item .title i").removeClass("fa-chevron-up").addClass("fa-chevron-down"); 
                $(this).children("i").toggleClass("fa-chevron-up fa-chevron-down");          
   
          }
    });

    //  *************** RESULT PAGE TOOLTIP  ******************
   
    $(".result_page_info_handler").click(function() {
        // console.log("tesy");
        $(".result_page_info_tooltip").toggle();
    });

//  *************** ACCORDION ******************
    
    $(".box-colored-grid").appendTo(".materials_block").css("opacity","1");

    if( window.screen.width < 767 ) {
        $(".categories_list").click(function(){
            $(".categories_dropdown").slideToggle();
        });
    }

//  *************** ACCORDION ******************
     $(".guest_form form").submit( function() {
        var isFormValid = true;
        var elem = $(".guest_form").find(".error-message");
        $(this).find("input").each( function() {
            if( $(this).val() == '' ) {
                isFormValid = false;
            }
        });
        if(!isFormValid) {
            elem.children("p").addClass("form-error").text( $(elem).attr("data-src") );
        } else {
            elem.children("p").removeClass("form-error").text('');
        }
        return isFormValid;
     });

    // *************** On click Modifier la liste ***************
    (function() {
        if (!document.querySelectorAll(".checkout-action .cta .categories_list")) {
            return;
        }
        const categoriesList = document.querySelectorAll(".checkout-action .cta .categories_list");
        categoriesList.forEach(element => {
            element.addEventListener("click", function() {
                if (element.classList.contains("active")) {
                    element.classList.remove("active");
                } else {
                    element.classList.add("active");
                }
            });
        });
        document.addEventListener('click', function(e) {
            e = e || window.event;
            var target = e.target || e.srcElement,
                targetClass = target.classList;
                if (!(target.parentElement.classList.contains("categories_list") || targetClass.contains("categories_list"))) {
                    categoriesList.forEach(element => element.classList.remove("active"));
                }
        }, false);
    })();

    // *************** On click Search Icon Header ***************
    (function() {
        const searchTrigger = document.querySelector(".search.js-open-search");
        searchTrigger.addEventListener("click", () => {
            if (document.querySelector(".mobile-menu.menu-icon")) {
                document.querySelector(".mobile-menu.menu-icon").click();
            }
            if (document.querySelector(".search-form-container")) {
                document.querySelector(".search-form-container").classList.toggle("active");
            }
            searchTrigger.classList.toggle("active");
        });
        
        const closeSearchMobile = document.querySelector(".close-search");
        closeSearchMobile.addEventListener("click", () => {
            document.querySelector(".search-form-container").classList.remove("active");
            searchTrigger.classList.toggle("active");
        });
    })();


 });
    }

    onDOMResize() {
        window.addEventListener("resize", (event) => {
            this.handleWidthChangePaginationNextPrev();
        });
    }

    onScrollDownAddBackdropSiteHeader() {
        let lastKnownScrollPosition = 0;
        window.addEventListener('scroll', function (e) {
            e.preventDefault();
            lastKnownScrollPosition = window.scrollY;
            if (!document.querySelector("header.site-header").offsetHeight) {
                return;
            }
            const siteHeader = document.querySelector("header.site-header");
            const searchFormContainer = document.querySelector(".search-form-container");
            if (lastKnownScrollPosition > document.querySelector("header.site-header").offsetHeight) {
                siteHeader.classList.add("backdrop");
                searchFormContainer.classList.add("fixed");
            } else {
                siteHeader.classList.remove("backdrop");
                searchFormContainer.classList.remove("fixed");
            }
        });
    }

    getWidth() {
        return window.innerWidth;
    }
    
    handleWidthChangePaginationNextPrev() {
        if (this.getWidth() < 350) {
            if (document.querySelector('.pagination .prev.page-numbers')) {
                document.querySelector('.pagination .prev.page-numbers').innerText = "«";
            }
            if (document.querySelector('.pagination .next.page-numbers')) {
                document.querySelector('.pagination .next.page-numbers').innerText = "»";
            }
        } else {
            if (document.querySelector("body[data-currentlang]")) {
                if (document.querySelector("body[data-currentlang]").dataset) {
                    let currentlang = document.querySelector("body[data-currentlang]").dataset.currentlang;
                    let prevText =  currentlang == "fr" ? "« Précédent" : "« Previous";
                    let nextText =  currentlang == "fr" ? "Suivant »" : "Next »";
                    if (document.querySelector('.pagination .prev.page-numbers')) {
                        document.querySelector('.pagination .prev.page-numbers').innerText = prevText;
                    }
                    if (document.querySelector('.pagination .next.page-numbers')) {
                        document.querySelector('.pagination .next.page-numbers').innerText = nextText;
                    }
                }
            }
            
        }
    }
}

new Main();


// WEBPACK FOOTER //
// ./src/scripts/index.js